import { render, staticRenderFns } from "./_resupply.tab.vue?vue&type=template&id=7860bae6&scoped=true"
import script from "./_resupply.tab.vue?vue&type=script&lang=js"
export * from "./_resupply.tab.vue?vue&type=script&lang=js"
import style0 from "./_resupply.tab.vue?vue&type=style&index=0&id=7860bae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7860bae6",
  null
  
)

export default component.exports